import * as api from '../../api/api-dashboard-recupero';
import { GET_METRICAS_RECUPERO } from '../types';

export const obtenerMetricasRecupero = (body) => ({
    type: GET_METRICAS_RECUPERO,
    payload: api.postMetricasRecupero(body)
});
